import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { FlowBuilderModule } from './modules/flow-builder/flow-builder.module';
import { HomePageComponent } from './modules/home-page/home-page.component';
import { TestComponent } from './modules/test/test.component';
import { MatMenuModule } from '@angular/material/menu';
import { InterceptorService } from './core/interceptor/interceptor.service';

@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    TestComponent,

  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    FlowBuilderModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatMenuModule,
    ToastrModule.forRoot({// required for toastr
      timeOut: 3200,
      preventDuplicates: true,
      countDuplicates: false,
      closeButton: true
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
